import React, { Suspense } from 'react'
import PublicPageLoader from '../../component/Elements/publicPageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const RegistrationSuccess = lazyWithRetry(() => import(/* webpackChunkName: "registration-success" */'../../component/Registration/Company/RegistrationSuccess'))

const RegistrationSuccessPage = React.memo(() => {
	return (
		<Suspense fallback={<PublicPageLoader className="authPage" />}>
			<RegistrationSuccess />
		</Suspense>
	)
})

RegistrationSuccessPage.displayName = 'RegistrationSuccessPage'
export default RegistrationSuccessPage
